export const capitalizeFirstLetter = (string) => {
  return string
    .charAt(0)
    .toUpperCase() + string
      .slice(1)
      .toLowerCase();
}

export const capitalizeEachWord = (phrase) => {
  return phrase
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getFullName = (profile) => {
  if (profile?.first_name && profile?.first_name !== '' || profile?.last_name && profile?.last_name !== '') {
    return (profile?.first_name ? profile?.first_name : "") + " " + (profile?.last_name ? profile?.last_name : "");
  } else if (profile) {
    return profile
  } else {
    return "-"
  }
}

export const getFullPhoneNumber = (profile) => {
  if (profile?.phone_number && profile?.phone_number !== '' && profile?.country && profile?.country?.phone_code && profile?.country?.phone_code !== '') {
    return (profile?.country?.phone_code ? profile?.country?.phone_code : "") + (profile?.phone_number ? profile?.phone_number : "");
  } else {
    return "-"
  }
}

export const random = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export const getEmailUser = (user) => {
  if (user?.email) {
    return user?.email
  } else {
    return "-"
  }
}

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};